"use client";

import { Award, Instagram, Linkedin, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheAiGuyzTeam() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const technicians = [{
    id: "AI-01",
    name: "MATT WINDELL",
    role: "GENERAL // AI STRATEGY ARCHITECT",
    bio: "Veteran-led leadership with a focus on automating client acquisition and streamlining business operations for local service providers.",
    stat1: "15+ YEARS",
    stat2: "500+ SYSTEMS",
    stat3: "VETERAN OWNED",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_founder_david.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_founder_david.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_founder_david.png-wvc-sizes"
  }, {
    id: "AI-02",
    name: "JOEY WINDELL",
    role: "COLONEL // AUTOMATION ENGINEER",
    bio: "Specialist in building custom AI answering agents and booking workflows that ensure no lead is ever missed, 24/7.",
    stat1: "5+ YEARS",
    stat2: "300+ DEPLOYMENTS",
    stat3: "AI CERTIFIED",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_founder_james.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_founder_james.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704929/img/ai_founder_james.webp-wvc-sizes"
  }];
  return <section data-section-id="3925" id="the-ai-guyz-team" className="bg-background text-foreground relative py-20 md:py-28 px-4 md:px-8 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.04]" style={{
      backgroundImage: "linear-gradient(var(--foreground) 1px, transparent 1px), linear-gradient(90deg, var(--foreground) 1px, transparent 1px)",
      backgroundSize: "48px 48px"
    }} aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto">
        {}
        <div className="flex items-center gap-3 mb-12">
          
          <div className="flex-1 h-px bg-border" />
        </div>

        {}
        <div ref={headerRef} className={`text-center mb-16 md:mb-20 transition-all duration-700 ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          
          <h2 className="font-serif font-default text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.95] tracking-tight">command section<span data-ast-id="f:/src/pages/OurMission/sections/TheAiGuyzTeam.tsx|sig:hzm3i1" data-ast-start="2785" data-ast-end="2856" style={{
            color: 'var(--primary)'
          }}></span></h2>
          <div className="flex items-center justify-center gap-2 mt-8">
            
            
            
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto justify-center">
          {technicians.map((tech, i) => <article key={tech.id} data-index={i} className="group relative bg-card border border-border rounded-lg overflow-hidden transition-all duration-300 hover:border-[var(--primary)] hover:shadow-lg">
              {}
              <div className="relative aspect-[4/5] overflow-hidden bg-muted">
                
                {}
                <div className="absolute top-3 left-3 flex items-center gap-2 bg-background/80 backdrop-blur-sm px-2 py-1 border border-border">
                  
                  
                </div>
                {}
                <Plus className="absolute top-2 right-2 w-3 h-3 text-foreground/40" />
                <Plus className="absolute bottom-2 left-2 w-3 h-3 text-foreground/40" />
                <Plus className="absolute bottom-2 right-2 w-3 h-3 text-foreground/40" />
              </div>

              {}
              <div className="p-6 md:p-8">
                <h3 className="font-serif font-default text-2xl md:text-[28px] uppercase leading-tight tracking-tight relative inline-block">
                  {tech.name}
                  <span className="absolute left-0 -bottom-0.5 h-px w-0 group-hover:w-full transition-all duration-300" style={{
                backgroundColor: "var(--primary)"
              }} />
                </h3>
                <p className="font-mono text-[11px] tracking-widest mt-2 mb-5" style={{
              color: "var(--primary)"
            }}>
                  {tech.role}
                </p>
                <p className="font-sans text-sm leading-relaxed text-muted-foreground line-clamp-3">
                  {tech.bio}
                </p>

                {}
                

                {}
                
              </div>
            </article>)}
        </div>

        {}
        <div className="my-16 md:my-20 flex items-center gap-4">
          <Plus className="w-3 h-3 text-muted-foreground" />
          <Separator className="flex-1 border-t border-dashed bg-transparent h-px [border-color:var(--border)]" />
          <Plus className="w-3 h-3 text-muted-foreground" />
        </div>

        {}
        
      </div>
    </section>;
}